import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, IdDescription, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { SupplierContact } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SupplierContactService extends TmsWebBaseEditCreateService<SupplierContact, SupplierContact> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('SupplierContact', $localize`Supplier Contact`, httpService, notificationService);
  }

  getForSupplier(id: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForSupplier/${id}`);
  }

  getSupplierContactsForSupplier(id: string): Observable<SupplierContact[]> {
    return this.httpService.get<SupplierContact[]>(`${this.apiUrl}/Supplier/${id}`);
  }
}
